import { styled } from 'styled-components';
import CardDescription from './cardDescription.jsx';



const Container=styled.div`
display:flex;
flex-wrap:wrap;
justify-content: space-evenly;

 `
const ContainerCard=styled.div`
 margin:10px;
`;
	
export default function Cards(props){
	let { reventas,open } = props;
	


 const handleClick = (juego) => () => open(juego);

	return(
		<Container>
		
			{ reventas?
				reventas.map( reventa=>reventa.publicar_reventa?
					<ContainerCard key={reventa.id} onClick={handleClick(reventa.Cuenta_Juego.Juego)} ><CardDescription key={reventa.id} reventa={reventa} /></ContainerCard>
								:null)

			:null }

		</Container>
		)
} 